export const config = {
  server: '/public/api',
};
